module.exports = __webpack_public_path__ + "img/home-deliver-section.eed231f9.svg";